import React from "react";
import { useFormikContext } from "formik";
import FormField from "../../../utils/FormFileds";
const Step3 = ({ fields }) => {
  const { errors, touched } = useFormikContext();
  return (
    <div className="grid  grid-cols-1 md:grid-cols-2 gap-4 w-full [&>*:nth-child(1)]:md:col-span-2 [&>*:nth-child(4)]:md:col-span-2 ">
      {Object.values(fields).map((field) => (
        <FormField
          key={field.name}
          {...field}
          error={errors[field.name]}
          touched={touched[field.name]}
        />
      ))}
    </div>
  );
};

export default Step3;
